/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncGringottsTokenFromFranklin} from '../api'

export const useMutationSyncGringottsTokenFromFranklin = createReactQueryMutationHook('syncGringottsTokenFromFranklin', syncGringottsTokenFromFranklin)
